import axios from 'axios'
const expiredDate = '2019-11-15'
export const getServerTime = async () => {
	try {
		const response = await axios.get('/')
		return new Date(response.headers.date).getTime()
	} catch (_) {
		return new Date().getTime()
	}
}

export const entryDeadline = new Date(expiredDate).getTime()
